(() => {
  const instances = new WeakMap();
  function initialize(root) {
    root.querySelectorAll('[data-questions]').forEach(section => {
      if (instances.has(section)) return;
      const controller = new AbortController(), options = { signal: controller.signal };
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      const states = [];
      section.querySelectorAll('[data-question]').forEach(item => {
        const summary = item.querySelector('summary'), panel = item.querySelector('[data-question-panel]');
        const state = { item, panel, animation: null, expanded: item.open, revision: 0 };
        states.push(state);
        summary.setAttribute('aria-expanded', String(item.open));
        summary.addEventListener('click', event => {
          event.preventDefault();
          const start = item.open ? panel.getBoundingClientRect().height : 0;
          state.animation?.cancel();
          state.expanded = !state.expanded;
          const revision = ++state.revision;
          summary.setAttribute('aria-expanded', String(state.expanded));
          panel.inert = !state.expanded;
          item.open = true;
          const end = state.expanded ? panel.scrollHeight : 0;
          function finish() {
            if (revision !== state.revision) return;
            item.open = state.expanded;
            state.animation?.cancel();
            state.animation = null;
          }
          if (reduce.matches || !panel.animate) { finish(); return; }
          state.animation = panel.animate([{ height: `${start}px` }, { height: `${end}px` }], {
            duration: 320, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'forwards'
          });
          state.animation.finished.then(finish).catch(() => {});
        }, options);
      });
      reduce.addEventListener('change', () => { if (reduce.matches) states.forEach(state => state.animation?.finish()); }, options);
      instances.set(section, () => { controller.abort(); states.forEach(state => state.animation?.cancel()); });
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-questions]').forEach(section => { instances.get(section)?.(); instances.delete(section); }));
})();
